/* eslint-disable import/prefer-default-export */
export const loadingTimeStatuses = {
  plenty: 'bg-success',
  limited: 'bg-warning',
  delayed: 'bg-danger',
  default: '',
};
